import { useLanguage } from "@web/lib/contexts/language-context";
import { motion } from "framer-motion";
import SealLoading from "./assets/BP_TAX_STAMP-CIRCLE.webp";

type QrCodeQueryLoadingProps = {
	scannedImage?: string;
	scannedImageAlt?: string;
};

export function QrCodeQueryLoading({
	scannedImage = SealLoading,
	scannedImageAlt = "Imagem do texto",
}: QrCodeQueryLoadingProps) {
	const { t } = useLanguage();
	return (
		<div className="fixed top-0 z-50 flex h-screen w-screen flex-col items-center justify-center bg-black font-mono">
			<div className="relative h-80 w-80 overflow-hidden  border-4 border-white bg-black rounded-full">
				<div className="absolute inset-0 z-0 flex items-center justify-center text-white/10">
					<motion.img
						src={scannedImage}
						alt={scannedImageAlt}
						className="h-60 w-60"
						animate={{ opacity: [0.6, 1, 0.6] }}
						transition={{
							duration: 1.5,
							repeat: Number.POSITIVE_INFINITY,
							ease: "easeInOut",
						}}
					/>
				</div>
				<motion.div
					className="pointer-events-none absolute inset-0 z-10 h-5 bg-black/70"
					animate={{ height: ["5%", "100%", "5%"] }}
					transition={{
						duration: 6,
						repeat: Number.POSITIVE_INFINITY,
						repeatType: "loop",
						ease: "easeInOut",
					}}
				/>
				<motion.div
					className="absolute right-5 left-5 z-20 h-1 rounded-lg bg-gray-400 shadow-primary"
					animate={{ top: ["5%", "100%", "5%"] }}
					transition={{
						duration: 6,
						repeat: Number.POSITIVE_INFINITY,
						repeatType: "loop",
						ease: "easeInOut",
					}}
				/>
			</div>
			<motion.h3
				className="mt-8 text-2xl text-white uppercase tracking-widest"
				animate={{ opacity: [0, 1, 0] }}
				transition={{
					duration: 1,
					repeat: Number.POSITIVE_INFINITY,
					repeatType: "loop",
				}}
			>
				{t.loading.validatingSeal}
			</motion.h3>
		</div>
	);
}
